import Grid from '@material-ui/core/Grid';
import { graphql, Link } from 'gatsby';
import * as React from 'react';
import styled from 'styled-components';
import Layout from '../components/Layout';
import AngleRight from '../components/AngleRight';
import jonWaiLing from '../images/careers/jonWaiLing.jpg';
import laptopCCOS from '../images/careers/laptopCCOS.jpg';
import peopleFingerStar from '../images/careers/peopleFingerStar.jpg';

const Section = styled.section`
	padding-top: 0;
	padding-bottom: 1em;
	font-weight: bold;

	& header {
		& .description-and-button {
			display: flex;
			flex-direction: column;
			margin-bottom: 1em;

			@media (${(props) => props.theme.mediumUp}) {
				flex-direction: row;
				justify-content: flex-start;
				align-items: center;
				margin-bottom: 2em;

				& h2 {
					margin-right: 3em;
				}
			}
		}

		& .primary-button {
			display: inline-block;
		}
	}

	& h1.blue,
	& h2.blue {
		color: #449EC5;
	}

	& p {
		margin-bottom: 1em;
		line-height: 1.7;
	}

	& .job-description {
		padding: 1em 0;
	}

	& .contact-us {
		margin-top: auto;

		& p {
			margin-left: auto;
			max-width: 13rem;
		}

		& a {
			color: ${(props) => props.theme.green};
		}
	}

	& ul {
		font-weight: normal;
		margin-left: 0;
		padding-left: 15px;
		margin-bottom: 2em;

		& li {
			margin-bottom: 0.7em;

			& ul {
				margin-bottom: 0;
			}

			& li {
				margin-bottom: 0;
			}
		}
	}

	& .qualifications {
		clear: both;
	}

	& .centered {
		margin: 2em 0;
		text-align: center;
		& .primary-button {
			margin: 0 auto;
		}
	}

	& .primary-button {
		max-width: 280px;
		text-align: center;
	}

	& div.col-lg-6 {
		padding-left: 0;
		padding-right: 0;
	}

	& figure.col-lg-6 {
		display: none;
	}

	@media (${(props) => props.theme.largeUp}) {

		& figure.col-lg-6 {
			display: block;
			text-align: right;
			padding-top: 20px;
			padding-right: 0;

			& img {
				margin-bottom: 20px;
			}
		}
	}

	& .additionalDescription {
		font-weight: normal;
	}
`;

interface ProductPageProps {
	classes: Record<string, any>;
	data: any;
}

const PositionDetailPage: React.StatelessComponent<ProductPageProps> = function (props) {
	const {
		data: { position },
		data: { site: { siteMetadata: { endpoint }}},
	} = props;
	const applyButton = <Link
		to='/application/' state={{ position }}
		className={`primary-button animate-right cta applyForPosition ${position.positionId}`}
	>
		Apply for Position<AngleRight />
	</Link>;

	const contactLink = <Link to='/contact/'>
		contact us
	</Link>;

	return <Layout
			pageTitle={position.title}
			splashHeaderMinHeight={'none'}
			skipMoney2020={true}
			skipUseCases={true}
		>
		<div className='centeredWrapper'>
			<Section>
				<header>
					<h1 className='blue'>{position.title}</h1>
					<div className='description-and-button'>
						<h2>{position.location}, {position.type}</h2>
						{applyButton}
					</div>
				</header>
				<div className='row row-flush'>
					<div className='col-12 col-lg-6'>
						<article className='job-description'>
							<h2>Job Description</h2>
							<div dangerouslySetInnerHTML={{ __html: position.description }} />
						</article>
						<div className='qualifications-responsibilities'>
							{ position.qualifications && <article className='qualifications'>
															<h2>Qualifications</h2>
															<ul>
																{position.qualifications.map((item: string, index: number) => <li key={index}>{item}</li> )}
															</ul>
														</article>
							}
							{ position.responsibilities && <article className='responsibilities'>
																<h2>Responsibilities</h2>
																<ul>
																	{position.responsibilities.map((item: string, index: number) => <li key={index}>{item}</li> )}
																</ul>
															</article>
							}
						</div>
						{/* {position.additionalDescription &&
							<div
								className='additionalDescription'
								dangerouslySetInnerHTML={{ __html: position.additionalDescription }}
							/>
						} */}
					</div>
					<figure className='col-12 col-lg-6'>
						<img src={jonWaiLing} alt='' />
						<img src={laptopCCOS} alt='' />
						<img src={peopleFingerStar} alt='' />
					</figure>
				</div>
				<div className='centered'>
				<h2 className='blue'>{position.title}</h2>
					<article>
						<p>{position.location}, {position.type}</p>
						{applyButton}
					</article>
				</div>
			</Section>
		</div>
	</Layout>;
};

export const query = graphql`
	fragment PositionFields on PositionsJson {
		applicationId
		category
		currentlyOpen
		description
		location
		positionId
		qualifications
		responsibilities
		title
		type
	}

	query PositionDetail ($positionId: String!) {
		position: positionsJson(
			positionId: { eq: $positionId }
		) {
			...PositionFields
		}

		site: site {
			siteMetadata {
				endpoint
			}
		}
	}
`;

export default PositionDetailPage;
